import { OccupancyType } from '../enums/occupancy-type.enum';
import { IdValue } from '../models/id-value.model';

export const occupancyTypes: IdValue[] = [
  new IdValue(OccupancyType.NotAssigned, 'NotAssigned', 'Select'),
  new IdValue(OccupancyType.PrimaryResidence, 'PrimaryResidence', 'Primary Residence'),
  new IdValue(OccupancyType.SecondaryResidence, 'SecondaryResidence', 'Secondary Residence'),
  new IdValue(OccupancyType.InvestmentProperty, 'InvestmentProperty', 'Investment Property'),
];

export const getLookupDisplayValue = (value: string, entries: IdValue[]) => {
  if (!value) {
    return null;
  }
  const entry: IdValue[] = entries.filter((entry) => entry.value === value);
  return (entry.length === 1 && entry[0].name) || '';
};
